
(function($) {
    "use strict";
    $(function() {

        $('.country-trigger').hover(function(){
            var id = $(this).data('country-id');

            $('.map-overlay:not(.map-overlay--base)').each(function(){
                $(this).attr('src','');
            });
            $('.map-click .label').removeClass('is-shown');
            $('.map-click .label--country-' + id).addClass('is-shown');
            $('.map-overlay--' + id).attr('src',$('.map-overlay--' + id).data('src'));
        }).mouseleave(function(){
            $('.map-overlay:not(.map-overlay--base)').each(function(){
                $(this).attr('src','');
                $('.map-click .label').removeClass('is-shown');
            });
        });

    });
})(jQuery);